import { TextField, Tooltip } from '@mui/material';
import { useState } from 'react';

const MuiValidTextField = ({ field, form: { touched, errors }, helpText = '', ...props }) => {
  const [showTip, setShowTip] = useState(false);

  return helpText ? (
    <>
      <Tooltip title={helpText} open={showTip}>
        <TextField
          error={!!(touched[field.name] && errors[field.name])}
          helperText={touched[field.name] && errors[field.name]}
          sx={{ width: '100%' }}
          {...field}
          {...props}
          // Events are here so that if a user hovers for the tool tip and then focuses the element
          // It goes away so their browser autocomplete does not overlap the tooltip
          onFocus={() => {
            setShowTip(false);
          }}
          onMouseEnter={() => {
            setShowTip(true);
          }}
          onMouseLeave={() => {
            setShowTip(false);
          }}
        />
      </Tooltip>
    </>
  ) : (
    <TextField
      error={!!(touched[field.name] && errors[field.name])}
      helperText={touched[field.name] && errors[field.name]}
      sx={{ width: '100%' }}
      {...field}
      {...props}
    />
  );
};

export default MuiValidTextField;
